import { hasStaticTagName } from '../has-static-tag-name';
import { makeCheckTransform, transformTemplate } from '../transform-template';
const cssChecksAndTransforms = [
    makeCheckTransform('tag name css selector interpolation', (lastNewString, currentLitString, currentValue) => {
        return hasStaticTagName(currentValue);
    }, (input) => 
    // cast is safe because the check method above verifies that this value is a VirElement
    input.tagName),
];
export function transformCssTemplate(inputTemplateStrings, inputValues) {
    return transformTemplate(inputTemplateStrings, inputValues, cssChecksAndTransforms);
}
